import { isLocal, isDev } from 'config/api.config'

const SUFFIX = isDev ? '.preview.dp-core.com' : ''
const ROOT = isLocal ? '' : '' // proxy host set in webpack.config.js
export const PAYMENT_ENGINE = `https://secure.datingfactory.com${SUFFIX}`

export const IMAGE = {
  basic: src => `${ROOT}/images/${src}`,
  sticker: (name, format) => `${ROOT}/images/stickers/${format}/${name}.${format}`,
}

// ===== ACCOUNT =====

export const AUTH = {
  LOGIN: `${ROOT}/api/login`,
  LOGOUT: `${ROOT}/app/logout`,
}

export const ACCOUNT = {
  GET: `${ROOT}/app/myprofile/update`,
  UPDATE: `${ROOT}/api/account`,
  DELETE: `${ROOT}/app/myprofile/remove`,
  RESEND_CONFIRMATION_EMAIL: `${ROOT}/app/registration/activation/resend`,
  REGISTRATION_CONFIRMATION: `${ROOT}/app/registration/confirmation`,
  HELP: `${ROOT}/app/contacts`,
  UNSUBSCRIBE_EMAILS: `${ROOT}/app/support/unsubscribe`,
}
export const PHOTO_FILTER = `${ROOT}/ws/rs/MemberService/myprofile/filter/edit/`
export const NOTIFICATION_SETTINGS = `${ROOT}/app/myprofile/update/subscriptions`
export const SUBSCRIPTIONS = {
  GET: `${ROOT}/app/payment/suspend`,
  delete: agreementId => `${ROOT}/app/payment/${agreementId}/suspend/confirmed`,
  form: agreementId => `${ROOT}/payment/${agreementId}/generate/`,
}

// ===== MY PROFILE =====
export const MY_PROFILE = `${ROOT}/api/myprofile`
export const PHOTO = {
  UPLOAD: `${ROOT}/app/myprofile/gallery/upload`,
  delete: (nickname, id) => `${ROOT}/ws/rs/MemberService/members/${nickname}/gallery/${id}/delete`,
  setDefault: (nickname, id) => `${ROOT}/ws/rs/MemberService/members/${nickname}/gallery/${id}/default.json`,
}

// ===== USERS =====
export const USER_PROFILE = `${ROOT}/api/members`
export const USER_PROFILE_BY_ID = `${ROOT}/api/members/byId`
export const USERS_SEARCH = `${ROOT}/api/search`
export const TOP_FLIRTS = `${ROOT}/api/topFlirts`
export const MY_FLIRTS = `${ROOT}/api/myFlirts`
export const FLIRTED_WITH_ME = `${ROOT}/api/flirtWithMe`
export const MUTUAL_FLIRTS = `${ROOT}/api/mutualFlirt`

export const FLIRT_ACCOUNTS = `${ROOT}/ws/rs/GameService/getAccountsPool.json`

// ===== INTERACTIONS =====
export const ACTIONS = {
  flirt: (user, like) => `${ROOT}/ws/rs/GameService/${like ? '' : 'dis'}like/${user.mediaId}.json`,
  friend: (user, like) => `${ROOT}/ws/rs/MemberService/myprofile/friends/${like ? 'add' : 'remove'}/${user.id}.json`,
  wink: user => `${ROOT}/ws/rs/MemberService/mailbox/create/${user.id}/wink`,
  chat: user => `${ROOT}/api/members/${user.nickname}/chat`,
}

export const MAILBOX = {
  INBOX: `${ROOT}/api/mailbox`,
  CARDS: `${ROOT}/api/mailbox/cards`,
  SEND: `${ROOT}/api/mailbox/send`,
  conversation: nickname => `${ROOT}/api/mailbox/conversation?withUser=${nickname}`,
  read: ({ id }) => `${ROOT}/api/mailbox/read?ids=${id}`,
  delete: ({ id }) => `${ROOT}/api/mailbox?ids=${id}`,
}

// ===== UPGRADE =====
export const UPGRADE = {
  params: ({ policyId = 1, referUser, itemId }) =>
    `?policyId=${policyId}${referUser ? `&referUser=${referUser}` : ''}${itemId ? `&itemId=${itemId}` : ''}`,
  page: (policyId, referUser, itemId) => `/payment/upgrade/${UPGRADE.params({ policyId, referUser, itemId })}`,
  ccp: isUpgraded => `${ROOT}/api/ccp/user/${isUpgraded ? 'up' : 'down'}grade`,
  details: params => `${ROOT}/api/upgrade/details${UPGRADE.params(params)}`,
}

// ===== SITE_DATA =====
export const SITE_CONFIG = `${ROOT}/api/site`

export const CONTENT = {
  REGISTRY: `${ROOT}/api/registry`,
  AGES: `${ROOT}/api/registry/ages`,
  LABELS: `${ROOT}/api/labels`,
  page: page => `${ROOT}/api/pages${page}`,
}

export const GEO = {
  ROOT: `${ROOT}/app/geoService`,
  regions: countryId => `${GEO.ROOT}/regions/byCountry/${countryId}.json`,
  citiesByRegion: regionId => `${GEO.ROOT}/cities/byRegion/${regionId}.json`,
  citiesByCountry: countryId => `${GEO.ROOT}/cities/byCountry/${countryId}.json`,
  search: (countryId, start) => `${GEO.ROOT}/cities/${countryId}/0/${start}.json`,
}

// ===== NOTIFICATIONS =====
export const NOTIFICATIONS = {
  GET: `${ROOT}/api/notifications`,
  consume: notification => `${ROOT}/api/notifications/${notification.id}/consume`,
}
export const OFFERS = `${ROOT}/api/offers`
export const AJAX_RENDER = `${ROOT}/ajaxRender.do`

// ===== BANNERS =====
export const bannerUrl = (instanceId, devMode = false) =>
  `${ROOT}/api/banners?instanceId=${instanceId}&devMode=${devMode}`

// ===== CCP WIDGET =====
export const widgetUrl =
  (isDev
    ? 'https://widget.staging.thedatingmessenger.com/ccp-widget/chat.js'
    : 'https://widget.thedatingmessenger.com/ccp-widget/chat.js') + `?t=${process.env.DEPLOY_TIME}`
